import axios from "axios";

let currentAudio = null;
let requestId = 0; // bumped on every stop/new request so late responses are ignored

window.ttsStatus = {
  playing: false,
  finished: true,
  cached: false,
  text: ""
};

export const stopSpeechKokoro = () => {
  requestId += 1;
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio = null;
  }
  window.ttsStatus.playing = false;
  window.ttsStatus.finished = true;
};

// lang is optional and only used if /v1/tts reads a `lang` query param.
export const playSpeechKokoro = async (text, lang = null, { onEnded, onFail } = {}) => {
  stopSpeechKokoro();
  const myId = requestId;
  try {
    window.ttsStatus.playing = true;
    window.ttsStatus.finished = false;
    window.ttsStatus.text = text;
    window.ttsStatus.cached = false;

    const response = await axios.get("https://admin.fefdybraingym.com/v1/tts", {
      params: lang ? { text, lang } : { text },
    });
    if (myId !== requestId) return; // a newer request or a stop took over

    window.ttsStatus.cached = response.data.data.cached;
    console.log("Response:", response.data);
    console.log("URL:", response.data.data.url);

    const audio = new Audio(response.data.data.url);
    currentAudio = audio;

    audio.onloadedmetadata = () => console.log("Loaded metadata");
    audio.oncanplay = () => console.log("Can play");
    audio.onerror = () => {
      console.log("Audio error", audio.error, audio.src);
      if (myId !== requestId) return;
      window.ttsStatus.playing = false;
      window.ttsStatus.finished = true;
      if (onFail) onFail(audio.error);
    };
    audio.onended = () => {
      if (myId !== requestId) return;
      window.ttsStatus.playing = false;
      window.ttsStatus.finished = true;
      if (onEnded) onEnded();
    };

    await audio.play();
  } catch (err) {
    if (myId !== requestId) return; // cancelled on purpose (pause() makes play() reject)
    window.ttsStatus.playing = false;
    window.ttsStatus.finished = true;
    console.error(err);
    if (onFail) onFail(err);
  }
};